import { render, staticRenderFns } from "./IconGezondheid.vue?vue&type=template&id=0ca76eb2"
import script from "./IconGezondheid.vue?vue&type=script&lang=ts"
export * from "./IconGezondheid.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports